import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const scrollToOffer = () => {
    const el = document.getElementById('price-block');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <section className="relative w-full min-h-screen flex flex-col items-center justify-center px-4 py-16 overflow-hidden" style={{
    background: 'radial-gradient(ellipse at 50% 0%, #132040 0%, #0a1628 60%)'
  }} data-id="element-108">
      {/* Subtle star-field background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-109">
        {[...Array(40)].map((_, i) => <div key={i} className="absolute rounded-full" style={{
        width: Math.random() * 2 + 1 + 'px',
        height: Math.random() * 2 + 1 + 'px',
        backgroundColor: 'rgba(201, 168, 76, 0.3)',
        top: Math.random() * 100 + '%',
        left: Math.random() * 100 + '%',
        opacity: Math.random() * 0.5 + 0.1
      }} data-id="element-110" />)}
      </div>

      {/* Gold top border */}
      <div className="absolute top-0 left-0 right-0 h-px" style={{
      background: 'linear-gradient(90deg, transparent, var(--color-gold), transparent)'
    }} data-id="element-111" />

      <div className="relative z-10 max-w-6xl mx-auto w-full" data-id="element-112">
        {/* Badge */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex justify-center mb-6" data-id="element-113">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-body font-700 tracking-widest uppercase" style={{
          background: 'rgba(201, 168, 76, 0.12)',
          border: '1px solid rgba(201, 168, 76, 0.4)',
          color: 'var(--color-gold-light)'
        }} data-id="element-114">
            <span data-id="element-115">✦</span>
            Restauración Celular en 21 Días
            <span data-id="element-116">✦</span>
          </span>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-117">
          {/* Left: Text */}
          <div className="text-center lg:text-left order-2 lg:order-1" data-id="element-118">
            <motion.h1 initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="font-heading font-700 mb-4" style={{
            color: 'var(--color-cream)'
          }} data-id="element-119">
              <span className="block text-4xl md:text-5xl lg:text-6xl leading-tight" data-id="element-120">
                El Código de la
              </span>
              <span className="block text-5xl md:text-6xl lg:text-7xl leading-tight shimmer-text" data-id="element-121">
                Longevidad Bíblica
              </span>
            </motion.h1>

            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.6,
            delay: 0.5
          }} className="gold-divider mb-6 lg:ml-0" data-id="element-122" />

            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.6
          }} className="font-heading text-xl md:text-2xl font-400 italic mb-8 leading-relaxed" style={{
            color: 'var(--color-cream-dim)'
          }} data-id="element-123">
              Recupera la vitalidad de hace 10 años uniendo los secretos del
              Génesis con la ciencia de la medicina regenerativa.
            </motion.h2>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.8
          }} className="font-body text-base md:text-lg mb-10 leading-relaxed" style={{
            color: 'var(--color-cream-dim)'
          }} data-id="element-124">
              Si te despiertas cada mañana con pesadez en las articulaciones,
              "niebla mental" y la sensación de que tu cuerpo se está
              convirtiendo en una carga...{' '}
              <strong style={{
              color: 'var(--color-cream)'
            }} data-id="element-125">
                no es solo "cosa de la edad".
              </strong>{' '}
              Es una señal de que tu templo biológico ha perdido su conexión con
              el diseño original.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 1.0
          }} className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-126">
              <button onClick={scrollToOffer} className="cta-button font-body font-700 text-lg px-8 py-4 rounded-lg uppercase tracking-wider transition-transform hover:scale-105 active:scale-95" style={{
              background: 'linear-gradient(135deg, #C9A84C, #E8C96A, #C9A84C)',
              color: '#0a1628'
            }} data-id="element-127">
                Sí, Quiero Restaurar Mi Vitalidad
              </button>
            </motion.div>

            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.6,
            delay: 1.2
          }} className="flex items-center gap-6 mt-6 justify-center lg:justify-start" data-id="element-128">
              <div className="flex items-center gap-2" data-id="element-129">
                <span style={{
                color: 'var(--color-olive)'
              }} data-id="element-130">
                  ✓
                </span>
                <span className="font-body text-sm" style={{
                color: 'var(--color-cream-dim)'
              }} data-id="element-131">
                  Acceso inmediato
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-132">
                <span style={{
                color: 'var(--color-olive)'
              }} data-id="element-133">
                  ✓
                </span>
                <span className="font-body text-sm" style={{
                color: 'var(--color-cream-dim)'
              }} data-id="element-134">
                  100% seguro
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-135">
                <span style={{
                color: 'var(--color-olive)'
              }} data-id="element-136">
                  ✓
                </span>
                <span className="font-body text-sm" style={{
                color: 'var(--color-cream-dim)'
              }} data-id="element-137">
                  Solo $27 USD
                </span>
              </div>
            </motion.div>
          </div>

          {/* Right: Book Image */}
          <motion.div initial={{
          opacity: 0,
          x: 40
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 1.0,
          delay: 0.4
        }} className="flex justify-center order-1 lg:order-2" data-id="element-138">
            <div className="relative" data-id="element-139">
              {/* Glow ring behind book */}
              <div className="absolute inset-0 rounded-2xl blur-3xl opacity-30" style={{
              background: 'radial-gradient(ellipse, #C9A84C 0%, #4A9EFF 50%, transparent 70%)',
              transform: 'scale(1.2)'
            }} data-id="element-140" />
              <img src="https://cdn.magicpatterns.com/uploads/9xngprzKDQDjsYz3zakWov/Portada_de_libro.png" alt="El Código de la Longevidad Bíblica — libro digital" className="floating-book relative z-10 w-full max-w-xs md:max-w-sm lg:max-w-md rounded-2xl" style={{
              filter: 'drop-shadow(0 25px 50px rgba(201, 168, 76, 0.4)) drop-shadow(0 0 80px rgba(74, 158, 255, 0.15))'
            }} data-id="element-141" />
            </div>
          </motion.div>
        </div>

        {/* Scroll indicator */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 1.5
      }} className="flex justify-center mt-16" data-id="element-142">
          <motion.div animate={{
          y: [0, 8, 0]
        }} transition={{
          duration: 1.5,
          repeat: Infinity
        }} className="flex flex-col items-center gap-2" style={{
          color: 'var(--color-gold-dim)'
        }} data-id="element-143">
            <span className="font-body text-xs tracking-widest uppercase" data-id="element-144">
              Descubre más
            </span>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" data-id="element-145">
              <path d="M5 7l5 5 5-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-146" />
            </svg>
          </motion.div>
        </motion.div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 pointer-events-none" style={{
      background: 'linear-gradient(to bottom, transparent, var(--color-navy))'
    }} data-id="element-147" />
    </section>;
}